import * as lodash from './lodash';
export function degToRad(theta) {
    return (theta * Math.PI) / 180;
}
export function radToDeg(theta) {
    return (theta * 180) / Math.PI;
}
export function normalizeAngle(deg) {
    return deg < 0 ? deg + 360 : deg;
}
// eslint-disable-next-line no-unused-vars
export function log(value, base) {
    if (value <= 0) {
        return 0;
    }
    return (Math.log(value) * Math.log(Math.E)) / Math.log(base);
}
export function log10(value) {
    if (value <= 0) {
        return 0;
    }
    return (Math.log(value) * Math.log(Math.E)) / Math.log(10);
}
export function getPercentOrNumberValue(percentOrNumber, fullValue) {
    return lodash.isNumber(percentOrNumber)
        ? percentOrNumber
        : (fullValue * parseInt(percentOrNumber, 10)) / 100;
}
export function isPercent(value) {
    return lodash.isString(value) && /\d+(\.\d+)?%/.test(value);
}
export function getPercentFromStringOrValue(value, percetOfWhat) {
    if (isPercent(value)) {
        return parseFloat(value) / 100;
    }
    if (lodash.isNumber(value)) {
        return value / percetOfWhat;
    }
    throw new Error(value + " is not a percent string of number");
}
export function inRange(value, range) {
    var min = lodash.min(range);
    var max = lodash.max(range);
    return value >= min && value <= max;
}
/**
 * get angle of offset
 * @param dx offset x
 * @param dy  offset y
 */
export function getOffsetAngle(dx, dy) {
    if (dx === dy && dx === 0) {
        return 0;
    }
    if (dx === 0) {
        if (dy > 0) {
            return 90;
        }
        return -90;
    }
    if (dy === 0) {
        if (dx > 0) {
            return 0;
        }
        return 180;
    }
    var angle = (Math.atan(dy / dx) * 180) / Math.PI;
    if (dx > 0 && dy > 0) {
        return angle;
    }
    if (dx > 0 && dy < 0) {
        return angle;
    }
    if (dx < 0 && dy > 0) {
        return angle + 180;
    }
    if (dx < 0 && dy < 0) {
        return angle + 180;
    }
}
export function getPolar(polar) {
    var cx = polar.cx, cy = polar.cy;
    return function (angle, r) {
        return {
            x: cx + Math.cos(degToRad(angle)) * r,
            y: cy + Math.sin(degToRad(angle)) * r,
        };
    };
}
//
export function getPercent(a, b, list, stackIndex) {
    if (list === void 0) { list = [0]; }
    if (stackIndex === void 0) { stackIndex = -1; }
    if (a === 0 && b === 0) {
        if (stackIndex === -1) {
            return (1 / list.length) * 100;
        }
        return (stackIndex / list.length) * 100;
    }
    return (a / b) * 100;
}
export function interpolateNumber(value, valueRange, domainRange) {
    var min = valueRange[0], max = valueRange[1];
    if (min === max) {
        return (domainRange[0] + domainRange[1]) / 2;
    }
    return domainRange[0] + ((value - min) / (max - min)) * (domainRange[1] - domainRange[0]);
}
// 最大余额法
export function getPercentListWithRemainderMethod(list, precision) {
    if (!list.length) {
        return [];
    }
    var sum = lodash.sum(list);
    var valueList = list;
    var digits = Math.pow(10, precision);
    var votesPerQuota = valueList.map(function (val) {
        return (val / sum) * digits * 100;
    });
    var targetSeats = digits * 100;
    var seats = votesPerQuota.map(function (votes) {
        return Math.floor(votes);
    });
    var currentSum = lodash.sum(seats);
    var remainder = votesPerQuota.map(function (votes, index) {
        return votes - seats[index];
    });
    while (currentSum < targetSeats) {
        var max = Number.NEGATIVE_INFINITY;
        var maxId = null;
        var len = remainder.length;
        for (var i = 0; i < len; ++i) {
            if (remainder[i] > max) {
                max = remainder[i];
                maxId = i;
            }
        }
        ++seats[maxId];
        remainder[maxId] = 0;
        ++currentSum;
    }
    return seats.map(function (seat) { return seat / digits; });
}
export function getValueListWithMinSizeRatio(list, minSizeRatio) {
    if (minSizeRatio === void 0) { minSizeRatio = 0; }
    var values = list.slice();
    if (minSizeRatio === 0) {
        return values;
    }
    if (!values.length) {
        return [];
    }
    var max = lodash.max(values);
    var min = lodash.min(values);
    var minValue = max * minSizeRatio;
    if (min < minValue && minSizeRatio > 0) {
        var grow_1 = (max - (1 / minSizeRatio) * min) / (1 / minSizeRatio - 1);
        values.forEach(function (value, index) {
            values[index] += grow_1;
        });
    }
    return values;
}
export function getPercentListWithMinSizeRatio(list, minSizeRatio) {
    if (minSizeRatio === void 0) { minSizeRatio = 0; }
    var values = getValueListWithMinSizeRatio(list, minSizeRatio);
    var sum = lodash.sum(values);
    return values.map(function (value) { return value / sum; });
}
